'use strict';

DoohApps
.directive('dateCheck', [function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var dateitem = '#' + attrs.dateCheck;
            elem.add(dateitem).on('keyup', function () {
                scope.$apply(function () {
                    //var v = elem.val() === $(firstPassword).val();
                    ctrl.$setValidity('date', false);
                });
            });
        }
    };
}]);